module.exports = __webpack_public_path__ + "img/lnicon.10c87372.svg";